module.exports = __webpack_public_path__ + "static/media/arrow-left.8e235d55.svg";